import { FAILURE, POST, SUCCESS, GET, PUT, DELETE } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";
import { FORMATO_FECHA } from "../utils/const/formato-fecha";
import { sharedApiErrorMessage } from "../utils/shared-functions";
import moment from "moment";

export async function obtenerListaProducto(obj, combo = false, tag) {
    try {
        let data = { error: true };
        const { status, message, body } = await fetch(
            `${BASE_URL}/producto/obtener-lista-productos`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            data.data = body;
            if (combo === true) {
                data.data = data.data.map(item => ({
                    label: `${item.codigo} - ${item.descripcion}`,
                    value: item.id,
                }));
            }
            if (combo === false) {
                data.data = data.data.map(item => ({
                    ...item,
                    habilitadoLabel: item.habilitado ? tag("label_habilitado") : tag("label_deshabilitado"),
                    fechaProceso: moment(item.fechaProceso).format(FORMATO_FECHA.YYYY_MM_DD_HH_MM_SS),
                }));
            }
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = sharedApiErrorMessage(message, tag?.("alert_process_failed"));
        }
        return data;
    } catch (err) {
        console.log("obtenerListaProducto err");
        console.log(err);
        return { error: true, message: sharedApiErrorMessage(err, tag?.("alert_process_failed")) };
    }
}

export async function crearProducto(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/producto/crear-producto`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearProducto err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function modificarProducto(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/producto/modificar-producto`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("modificarProducto err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarProducto(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/producto/deshabilitar-producto`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarProducto err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarProducto(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/producto/habilitar-producto`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarProducto err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaProductosPublicos(obj, tag) {
    try {
        let data = { error: true };
        const { status, message, body } = await fetch(
            `${BASE_URL}/producto/obtener-lista-productos-publicos`,
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = sharedApiErrorMessage(message, tag("alert_process_failed"));
        }
        return data;
    } catch (err) {
        console.log("obtenerListaProductosPublicos err");
        console.log(err);
        return { error: true, message: sharedApiErrorMessage(err, tag("alert_process_failed")) };
    }
}

export async function obtenerProductoXId(obj, tag) {
    try {
        let data = { error: true };
        const { status, message, body } = await fetch(
            `${BASE_URL}/producto/obtener-producto-x-id`,
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = sharedApiErrorMessage(message, tag("alert_process_failed"));
        }
        return data;
    } catch (err) {
        console.log("obtenerProductoXId err");
        console.log(err);
        return { error: true, message: sharedApiErrorMessage(err, tag("alert_process_failed")) };
    }
}